import { OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { OrderService } from "../../shared/services/order.service";
var ViewOrderPageComponent = /** @class */ (function () {
    function ViewOrderPageComponent(route, orderService) {
        this.route = route;
        this.orderService = orderService;
    }
    ViewOrderPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var orderId = +params['id'];
            // TODO: stephen check for Nan
            _this.orderService.getOrder(orderId)
                .then(function (order) {
                if (order == null) {
                    // TODO: stephen handle not found order.
                    console.error("Order not found");
                }
                _this._order = order;
                console.log("order found: ", _this._order);
            })
                .catch(function (error) {
                console.error(error);
            });
        });
    };
    Object.defineProperty(ViewOrderPageComponent.prototype, "order", {
        get: function () {
            return this._order;
        },
        enumerable: true,
        configurable: true
    });
    return ViewOrderPageComponent;
}());
export { ViewOrderPageComponent };



// WEBPACK FOOTER //
// ./src/app/admin/view-order-page/view-order-page.component.ts.pre-build-optimizer.js